document.addEventListener('DOMContentLoaded', () => {
    const WISHLIST_KEY = 'refit_wishlist';
    
    // Helper to get wishlist from local storage
    const getWishlist = () => {
        const wishlist = localStorage.getItem(WISHLIST_KEY);
        return wishlist ? JSON.parse(wishlist) : [];
    };

    // Helper to save wishlist
    const saveWishlist = (wishlist) => {
        localStorage.setItem(WISHLIST_KEY, JSON.stringify(wishlist));
        updateWishlistCount();
        document.dispatchEvent(new CustomEvent('wishlist:updated', { detail: { wishlist } }));
    };

    // Update header count
    const updateWishlistCount = () => {
        const wishlist = getWishlist();
        const countElements = document.querySelectorAll('[data-wishlist-count]');
        countElements.forEach(el => {
            el.textContent = wishlist.length;
        });
    };

    // Add item to wishlist
    window.addToWishlist = (handle) => {
        const wishlist = getWishlist();
        if (!wishlist.includes(handle)) {
            wishlist.push(handle);
            saveWishlist(wishlist);
            // Optional: Show feedback (toast, etc.)
            console.log('Added to wishlist:', handle);
        }
    };

    // Remove item from wishlist
    window.removeFromWishlist = (handle) => {
        let wishlist = getWishlist();
        wishlist = wishlist.filter(item => item !== handle);
        saveWishlist(wishlist);
        console.log('Removed from wishlist:', handle);
    };

    // Toggle wishlist item
    window.toggleWishlist = (handle) => {
        const wishlist = getWishlist();
        if (wishlist.includes(handle)) {
            removeFromWishlist(handle);
        } else {
            addToWishlist(handle);
        }
    };
    
    // Initial count update
    updateWishlistCount();
});
